import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"
import DrillController from "./controllers/drill_controller"
import SourcePickerController from "./controllers/source_picker_controller"
import AiFeedbackPollerController from "./controllers/ai_feedback_poller_controller"
import NavDrawerController from "./controllers/nav_drawer_controller"

const application = Application.start()
application.register("drill", DrillController)
application.register("source-picker", SourcePickerController)
application.register("ai-feedback-poller", AiFeedbackPollerController)
application.register("nav-drawer", NavDrawerController)
